"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _constants = require("../../constants");

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _reducers = require("../../reducers");

var _CallbackContext = _interopRequireDefault(require("../../context/CallbackContext"));

var _selectors = require("../../selectors");

var _AppContext = _interopRequireDefault(require("../../context/AppContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Delta component that fires onCommentsUpdate when delta changes
 * @returns {undefined}
 */
var useOnCommentsUpdate = function useOnCommentsUpdate() {
  var _appContext$assetData;

  var appContext = (0, _react.useContext)(_AppContext.default);
  var visibleComments = (0, _reducers.useSelector)(function (state) {
    return (0, _selectors.getFilteredComments)(state, appContext);
  });
  var commentCounts = (0, _reducers.useSelector)(function (state) {
    return (0, _selectors.getCommentCounts)(state, appContext);
  });
  var reduxState = (0, _reducers.useStore)().getState();
  var _reduxState$ = reduxState["".concat(_constants.PREFIX, ":delta")],
      data = _reduxState$.data,
      lastRequestAssetId = _reduxState$.lastRequestAssetId,
      reason = _reduxState$.reason;
  var showAnnotations = reduxState["".concat(_constants.PREFIX, ":comments")].showAnnotations;

  var _useContext = (0, _react.useContext)(_CallbackContext.default),
      onCommentsUpdate = _useContext.onCommentsUpdate;

  var commentCountsRef = (0, _react.useRef)(commentCounts);
  var reasonRef = (0, _react.useRef)(reason);
  var assetData = appContext.assetData;
  var assetIdRef = (0, _react.useRef)((_appContext$assetData = appContext.assetData) === null || _appContext$assetData === void 0 ? void 0 : _appContext$assetData.id);
  (0, _react.useEffect)(function () {
    assetIdRef.current = assetData === null || assetData === void 0 ? void 0 : assetData.id;
  }, [assetData]);
  (0, _react.useEffect)(function () {
    if (data && reason) {
      onCommentsUpdate(commentCounts, {
        showAnnotations: showAnnotations,
        reason: reason,
        data: _objectSpread(_objectSpread({}, data), {}, {
          visibleComments: visibleComments
        })
      }, {
        assetId: lastRequestAssetId
      });
    } // This line is disabled so we only fire this when delta related data changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [data, lastRequestAssetId, reason]);
  (0, _react.useEffect)(function () {
    if (reason && !(0, _lodash.default)(commentCounts, commentCountsRef.current) && reason === reasonRef.current) {
      onCommentsUpdate(commentCounts, {
        showAnnotations: showAnnotations,
        reason: 'counts-change',
        data: {
          visibleComments: visibleComments
        }
      }, {
        assetId: assetIdRef.current
      });
    }

    commentCountsRef.current = _objectSpread({}, commentCounts);
    reasonRef.current = reason; // This line is disabled so we only fire this when commentCounts or reason change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentCounts, reason]);
};

var _default = useOnCommentsUpdate;
exports.default = _default;